import React from "react";
import { Heart, Zap, Activity, Gauge, Flame, Timer } from "lucide-react";

/** Canonical session/exercise HR metric icon set (aligned with iOS SF Symbols / Android drawables). */
export const HR_METRIC_ICON = {
  duration: Timer,
  max: Heart,
  max_intensity: Zap,
  avg: Activity,
  avg_intensity: Gauge,
  calories: Flame,
  intensity: Zap,
  min: Heart,
};

export const HR_METRIC_ICON_COLOR = {
  duration: "#64D2FF",
  max: "#FF453A",
  max_intensity: "#AF52DE",
  avg: "#34C759",
  avg_intensity: "#0877BC",
  calories: "#FF9500",
  intensity: "#AF52DE",
  min: "#007AFF",
};

export function HrMetricIcon({
  variant = "max",
  size = 14,
  className = "",
  style = undefined,
}) {
  const Icon = HR_METRIC_ICON[variant] || Heart;
  const color = HR_METRIC_ICON_COLOR[variant] || HR_METRIC_ICON_COLOR.max;
  return (
    <Icon
      size={size}
      className={className}
      style={{ color, flexShrink: 0, ...style }}
      aria-hidden="true"
    />
  );
}

export default HrMetricIcon;
